<template>
  <div>
    <Header :actived="'catalog'"></Header>
    <div class="catalog">
      <div class="content">
        <div class="aside">
          <ul>
            <!-- <li @click="allProduct"><span>All products</span></li> -->
            <li v-for="(item, index) in typeList" :key="index">
              <span
                @click="choiceCate(item.name, index)"
                :class="{ active: index == actived }"
                >{{ item.name }}</span
              >
              <div
                v-show="item.show"
                class="aside-two"
                @click="choiceCate2(item2, index, index2)"
                v-for="(item2, index2) in item.list"
                :class="{ actived: item2.actived == true }"
                :key="index2"
              >
                <em>
                  {{ item2.name }}
                </em>
              </div>
            </li>
          </ul>
        </div>
        <div class="main">
          <!-- ------------------------------------------------------视图变小出现的内容start-------------------------------------------------- -->
          <div class="cate">
            <div class="title">Choose by Category</div>
            <div class="scoll">
              <ul>
                <li class="active">
                  <a>All Products</a>
                </li>
                <li
                  v-for="(item, index) in typeList"
                  :key="index"
                  @click="smallChoiceCate(item)"
                >
                  <a>{{ item.name }}</a>
                </li>
              </ul>
            </div>
            <!-- ------------------------------------------------------视图变小出现的内容END-------------------------------------------------- -->
          </div>
          <div style="padding-left:16px">
            <a-input-search
              placeholder="Search by model title"
              size="large"
              v-model="page.keyword"
              @search="keywordChange"
            />
          </div>
          <div
            class="product"
            v-infinite-scroll="load"
            infinite-scroll-distance="0"
            infinite-scroll-throttle-delay="500"
          >
            <ul class="infinite-list">
              <div v-for="(item2, index1) in product" :key="index1">
                <h2>{{ item2.title }}</h2>
                <div
                  class="clearfix"
                  v-for="(item3, index2) in item2.arr"
                  :key="index2"
                >
                  <h3>{{ item3.name }}</h3>
                  <li v-for="(item, index3) in item3.child" :key="index3">
                    <div
                      class="product-list"
                      @click="goDetail(item.id, item.model)"
                    >
                      <div class="posi">
                        <div class="tag" v-if="item.isNew">new</div>
                        <div class="tag tagHot" v-if="item.isHot">hot</div>
                        <div
                          class="tag tagzk"
                          v-if="item.favorableDiscount > 0"
                        >
                          -{{ item.favorableDiscount | percentFilter }}
                        </div>
                      </div>
                      <div
                        class="product-img"
                        @mouseenter="
                          changeImageSrc(
                            item.suspendImageUrl,
                            item.mainShowImageUrl,
                            index1,
                            index2,
                            index3,
                            'hover'
                          )
                        "
                        @mouseleave="
                          changeImageSrc(
                            item.suspendImageUrl,
                            item.mainShowImageUrl,
                            index1,
                            index2,
                            index3,
                            ''
                          )
                        "
                      >
                        <images
                          :url="item.mainShowImageUrl"
                          :width="imgWidth"
                          :height="imgHeight"
                        ></images>
                        <!-- <img :src="item.mainShowImageUrl" /> -->
                      </div>
                      <div class="info">
                        <p class="name ellipsis2">{{ item.model }}</p>
                        <p v-html="item.blankContent"></p>
                        <p class="price">
                          Price
                          <span v-if="item.favorablePrice">
                            <span
                              >${{ item.favorablePrice | MoneyFormat }}</span
                            >
                            <s>${{ item.price | MoneyFormat }}</s>
                          </span>
                          <span v-else>
                            <span>${{ item.price | MoneyFormat }}</span>
                          </span>
                        </p>
                      </div>
                    </div>
                  </li>
                </div>
              </div>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// @ is an alias to /src
// import Header from "../components/Header";
import images from "@/components/images";
import Header from "../../components/Header";
import { typeList, blankProductPage } from "../../api/product";
export default {
  name: "Home",
  components: {
    Header,
    images
  },
  data() {
    return {
      imgWidth: 600,
      imgHeight: 600,
      curr: 0,
      actived: 0,
      typeList: [], //菜单列表
      typeListId: [],
      product: [], //产品信息
      keyword: "", // 产品搜索
      pageTotal: 1,
      // pagenum: 0,
      page: {
        current: 0,
        size: 12,
        keyword: "", //关键字
        typeId: null,
        isIndexRecommend: true
      }
    };
  },
  methods: {
    changeImageSrc(susImg, mainImg, index, index2, index3, type) {
      console.log(type);
      if (susImg) {
        this.product[index].arr[index2].child[index3].mainShowImageUrl = susImg;
        this.product[index].arr[index2].child[index3].suspendImageUrl = mainImg;
        this.$forceUpdate();
      }
    },
    load() {
      this.page.current += 1;
      this.blankProduct();
    },
    //选择1级菜单
    choiceCate(name, index) {
      console.log(this.typeList);
      this.curr = 0;
      this.typeListId = [];
      if (index == 0) {
        const types = this.typeList;
        types.map(item => {
          item.list.map(item2 => {
            let param = {};
            param.pid = item.id;
            param.name = item2.name;
            param.title = item.name;
            param.id = item2.id;
            this.typeListId.push(param);
          });
        });
      } else {
        if (this.typeList[index].list.length > 0) {
          this.typeList[index].list.map(item => {
            let param = {};
            param.name = item.name;
            param.id = item.id;
            param.pid = item.pid;
            param.title = item.title;
            this.typeListId.push(param);
          });
        } else {
          let param = {};
          param.name = this.typeList[index].name;
          param.id = this.typeList[index].id;
          param.pid = this.typeList[index].pid;
          param.title = this.typeList[index].title;
          this.typeListId.push(param);
        }
      }
      console.log("typeId...");
      console.log(this.typeListId);

      this.product = [];
      this.page.current = 1;
      this.actived = index;
      if (index != 0) {
        console.log("lenmne...." + this.typeList[index].list.length);
        if (this.typeList[index].list.length > 0) {
          this.page.typeId = this.typeList[index].list[0]["id"];
        } else {
          this.page.typeId = this.typeList[index].id;
        }
      } else {
        this.curr = 0;
        this.page.typeId = this.typeListId[index]["id"];
      }
      for (let i = 0; i < this.typeList.length; i++) {
        this.typeList[i].show = false;
        for (let j = 0; j < this.typeList[i]["list"].length; j++) {
          if (this.typeList[i]["list"][j]["actived"] == true) {
            this.typeList[i]["list"][j]["actived"] = false;
          }
        }
      }
      this.typeList[index].show = this.typeList[index].show ? false : true;
      this.blankProduct();
    },
    //选择2级菜单
    choiceCate2(item, index, index2) {
      console.log(item);
      this.product = [];
      this.page.current = 1;
      for (let i = 0; i < this.typeList.length; i++) {
        for (let j = 0; j < this.typeList[i]["list"].length; j++) {
          this.typeList[i]["list"][j]["actived"] = false;
        }
      }
      this.curr = 0;
      this.typeListId = [];
      let param = {};
      param.name = item.name;
      param.id = item.id;
      param.pid = item.pid;
      param.title = item.title;
      this.typeListId.push(param);
      this.actived = index;
      this.typeList[index]["list"][index2]["actived"] = true;
      this.page.typeId = this.typeList[index]["list"][index2]["id"];
      this.blankProduct();
    },
    smallChoiceCate(item) {
      this.product = [];
      this.page.typeId = item.id;
      this.blankProduct();
    },
    //搜索框改变
    async keywordChange() {
      this.page.current = 1;
      this.product = [];
      this.typeListId = [];
      let { data } = await blankProductPage({
        current: this.page.current,
        size: this.page.size,
        keyword: this.page.keyword,
        typeId: ""
      });
      if (data.records) {
        const param = {};
        param.title = "";
        param.pid = "";
        param.arr = [];
        const childArr = {
          id: "",
          name: "",
          child: data.records
        };
        param.arr.push(childArr);
        this.product.push(param);
        // this.product.push(...data.records);
      }
    },
    switchLang() {
      this.$i18n.locale = this.lang;
    },
    //去产品详情页
    goDetail(id, name) {
      this.$router.push({
        path: "product-detail",
        query: { id: id, productName: name }
      });
    },
    //白板列表
    async blankProduct() {
      console.log(this.typeListId);
      //curr只要加载完就+1，没加载完的话就不用管
      if (!this.page.typeId) {
        return;
      }
      const typeid = this.page.typeId;
      let { data } = await blankProductPage({
        current: this.page.current,
        size: this.page.size,
        keyword: this.page.keyword,
        typeId: typeid
      });
      this.pageTotal = data.total;
      //查找全部
      let typeListIdLen = this.typeListId.length - 1;
      let len = this.product.length;
      const param = {};
      let typeslistId = this.typeListId;
      let cur = this.curr;
      // let product = this.product;
      if (data.records.length > 0) {
        if (len == 0) {
          param.title = typeslistId[cur].title;
          param.pid = typeslistId[cur].pid;
          param.arr = [];
          const objArr = {
            id: typeslistId[cur].id,
            name: typeslistId[cur].name,
            child: data.records
          };
          param.arr.push(objArr);
          this.product.push(param);
          if (data.records.length < 4) {
            if (cur < typeListIdLen) {
              cur = cur + 1;
              this.curr = cur;
              this.page.typeId = typeslistId[cur].id;
              this.page.current = 1;
              this.blankProduct();
            }
          }
          return;
        }
        //同一个大类(同一层arr)
        if (typeslistId[cur].pid == this.product[len - 1].pid) {
          //同一个小类(同一层child)
          if (
            this.page.typeId ==
            this.product[len - 1].arr[this.product[len - 1].arr.length - 1].id
          ) {
            this.product[len - 1].arr[
              this.product[len - 1].arr.length - 1
            ].child.push(...data.records);
          } else {
            const obj = {
              id: typeslistId[cur].id,
              name: typeslistId[cur].name,
              child: data.records
            };
            this.product[len - 1].arr.push(obj);
          }
        } else {
          param.title = typeslistId[cur].title;
          param.pid = typeslistId[cur].pid;
          param.arr = [];
          const objArr = {
            id: typeslistId[cur].id,
            name: typeslistId[cur].name,
            child: data.records
          };
          param.arr.push(objArr);
          this.product.push(param);
        }
      } else if (data.records.length == 0 && this.product.length == 0) {
        this.bankPage();
      } else {
        if (cur < typeListIdLen) {
          cur = cur + 1;
          this.curr = cur;
          this.page.typeId = typeslistId[cur].id;
          this.page.current = 1;
          this.blankProduct();
        }
      }
      console.log(this.product);
    },
    async bankPage() {
      let { data } = await blankProductPage({
        current: this.page.current,
        size: this.page.size,
        keyword: this.page.keyword,
        typeId: this.page.typeId
      });
      if (data.records.length > 0) {
        const param = {};
        param.title = this.typeListId[this.curr].title;
        param.pid = this.typeListId[this.curr].pid;
        param.arr = [];
        const objArr = {
          id: this.typeListId[this.curr].id,
          name: this.typeListId[this.curr].name,
          child: data.records
        };
        param.arr.push(objArr);
        this.product.push(param);
        if (data.records.length < 4) {
          this.curr = this.curr + 1;
          this.page.typeId = this.typeListId[this.curr].id;
          this.page.current = 1;
          this.bankPage();
        }
      } else {
        this.curr = this.curr + 1;
        this.page.typeId = this.typeListId[this.curr].id;
        this.page.current = 1;
        this.bankPage();
      }
    },
    async typeLists() {
      let { data } = await typeList();
      // this.typeList = data.records;
      const level1List = [];
      const allParam = {};
      allParam.id = "";
      allParam.level = 1;
      allParam.name = "All Products";
      allParam.pid = "";
      allParam.sort = 0;
      allParam.list = [];
      level1List.push(allParam);
      const level2List = [];
      for (let t = 0; t < data.records.length; t++) {
        if (data.records[t].level == 1) {
          const param = {};
          param.id = data.records[t].id;
          param.level = data.records[t].level;
          param.name = data.records[t].name;
          param.pid = data.records[t].pid;
          param.sort = data.records[t].sort;
          param.list = [];
          level1List.push(param);
        } else {
          const param2 = {};
          param2.id = data.records[t].id;
          param2.level = data.records[t].level;
          param2.name = data.records[t].name;
          param2.pid = data.records[t].pid;
          param2.sort = data.records[t].sort;
          level2List.push(param2);
        }
      }
      for (let i = 0; i < level1List.length; i++) {
        for (let j = 0; j < level2List.length; j++) {
          if (level1List[i]["id"] == level2List[j]["pid"]) {
            const param = {};
            param.title = level1List[i].name;
            param.id = level2List[j].id;
            param.level = level2List[j].level;
            param.name = level2List[j].name;
            param.pid = level2List[j].pid;
            param.sort = level2List[j].sort;
            param.actived = false;
            level1List[i].list.push(param);
          }
        }
      }
      this.typeList = level1List;
      const types = level1List;
      types.map(item => {
        item.list.map(item2 => {
          let param = {};
          param.pid = item.id;
          param.name = item2.name;
          param.title = item.name;
          param.id = item2.id;
          this.typeListId.push(param);
        });
      });
      this.page.typeId = this.typeListId[0].id;
      this.blankProduct();
    }
  },
  async mounted() {
    this.typeLists();
  }
};
</script>
<style scoped>
.catalog .content {
  padding: 0 16px;
  max-width: 1168px;
  margin: 0 auto;
  display: flex;
  margin-top: 40px;
}
.catalog .aside {
  width: 281px;
  padding-left: 16px;
  position: fixed;
  top: 105px;
}
.catalog .aside ul li {
  text-align: left;
  cursor: pointer;
}
.catalog .aside ul li p {
  margin-bottom: 0;
}
.catalog .aside ul li .aside-two {
  /* padding-left: 35px;
  color: #7e8c8d;
  padding: 7px 19px;
  padding-bottom: 10px;
  margin-bottom: 10px;
  padding-left: 39px;
  font-size: 16px; */
}
.catalog .aside ul li .aside-two em {
  display: inline-block;
  padding-left: 35px;
  color: #7e8c8d;
  padding: 10px 19px;
  padding-left: 39px;
  font-size: 16px;
  font-style: normal;
  min-width: 188px;
  padding-right: 39px;
}
.catalog .aside ul li .aside-two.actived {
  color: #106ebe;
}
.catalog .aside ul li .aside-two em:hover {
  color: #106ebe;
  background: #f1f1f1;
}
.catalog .aside ul li span.active {
  color: #106ebe;
  border-left: 2px solid #106ebe;
  background-color: #f5f5f5;
}
.catalog .aside ul li span.activeOne {
  color: #106ebe;
  border-left: 2px solid #106ebe;
  background-color: #f5f5f5;
}
.catalog .aside ul li span:hover {
  color: #106ebe;
  background: #f1f1f1;
}
.catalog .aside ul li span {
  color: #7e8c8d;
  font-size: 16px;
  height: 36px;
  padding: 7px 19px;
  padding-bottom: 10px;
  min-width: 188px;
  display: inline-block;
  margin-bottom: 10px;
}
.catalog .main {
  flex: 1;
  padding: 16px 0;
  padding-top: 0px;
  overflow: hidden;
  margin-left: 281px;
}
.catalog .search {
  width: 98%;
  padding: 0 16px;
  position: relative;
}
.catalog .search input {
  padding: 10px 42.5px;
  color: rgba(56, 56, 56, 0.3);
  box-shadow: none;
  transition: all 0.3s ease-in-out;
  display: block;
  width: 100%;
  background-color: #fff;
  background-image: none;
  border: 1px solid #ccc;
  height: 46px;
  font-size: 18px;
  line-height: 1.3333333;
  border-radius: 6px;
  box-sizing: border-box;
  overflow: visible;
  outline: none;
}
.catalog .search input::-webkit-input-placeholder {
  /*Webkit browsers*/
  color: rgba(56, 56, 56, 0.3);
}
.catalog .search input:-moz-placeholder {
  /*Mozilla Firefox 4 to 8*/
  color: rgba(56, 56, 56, 0.3);
}
.catalog .search input::moz-placeholder {
  /*Mozilla Firefox 19+*/
  color: rgba(56, 56, 56, 0.3);
}
.catalog .search input:-ms-input-placeholder {
  /*Internet Explorer 10+*/
  color: rgba(56, 56, 56, 0.3);
}
.catalog input[type="text"]:hover {
  box-shadow: 0px 0px 5px #888888;
}
.catalog input[type="text"]:focus {
  box-shadow: 0px 0px 5px #888888;
}
.catalog .search .search-icon {
  position: absolute;
  left: 30px;
  width: 16px;
  height: 16px;
  line-height: 16px;
  top: 50%;
  transform: translateY(-50%);
}
.catalog .search .delete-icon {
  position: absolute;
  right: 30px;
  top: 50%;
  transform: translateY(-50%);
  opacity: 0.3;
  cursor: pointer;
  transition: opacity 0.3s ease;
}
.catalog .product {
  width: 100%;
}
.catalog .product h3 {
  font-size: 27px;
  padding: 16px;
  font-weight: bold;
  padding-bottom: 0;
}
.catalog .product h2 {
  padding-left: 16px;
  font-size: 33px;
  margin-bottom: 16px;
  font-weight: bold;
  margin-top: 32px;
}
.catalog .product ul {
  width: 100%;
}
.catalog .product ul li {
  float: left;
  width: 33.3%;
  border-radius: 2px;
  padding: 16px 0px 16px 16px;
  box-sizing: border-box;
  height: 442px;
}
.catalog .product-list {
  position: relative;
  display: block;
  color: inherit;
  border-radius: 2px;
  transition: all 0.25s ease;
  cursor: pointer;
  text-decoration: none;
  outline: none;
}
.product-list .posi {
  position: absolute;
  top: 0;
  left: 0;
  width: 100px;
  z-index: 1;
}
.catalog .product-list .tag {
  text-align: center;
  min-width: 50px;
  max-width: 70px;
  height: 26px;
  padding: 4px 10px;
  border-radius: 3px;
  font-size: 13px;
  line-height: 18px;
  color: white;
  z-index: 1;
  background: #409eff;
  margin-top: 8px;
  margin-left: 16px;
}
.catalog .product-list .tag:nth-child(1) {
  margin-top: 16px;
}
.tagHot {
  color: #333 !important;
  background: #ffd700 !important;
}
.tagtop16 {
  background: #ffd700 !important;
}
.tagzk {
  color: white !important;
  background: red !important;
}

.catalog .product-img {
  overflow: hidden;
  width: 100%;
  height: 230px;
  margin-bottom: 16px;
  position: relative;
  text-align: center;
}
.catalog .product-img img {
  object-fit: contain;
  object-position: center;
  position: absolute;
  width: 230px;
  height: 230px;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  transition: all 0.25s ease;
}
.catalog .product-list:hover {
  box-shadow: 0 0 4px 2px rgba(56, 56, 56, 0.3);
  border-color: transparent;
  background-color: #f6f7f6;
}
.catalog .product-list:hover .product-img img {
  transform: translate(-50%, -50%) scale(1.2);
}
.catalog .product-list .info {
  padding: 16px;
  text-align: left;
}
.catalog .product-list .info p {
  margin: 0;
}
.catalog .info .name {
  font-size: 16px;
  max-width: 100%;
  word-break: break-all;
  /* overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap; */
}
.catalog .info .price {
  margin-top: 12px;
  font-size: 16px;
}
.catalog .info .price span {
  margin-right: 13px;
}
.catalog .info .price s {
  color: #949494;
}

.catalog .cate {
  display: none;
}
@media only screen and (max-width: 1100px) {
  .catalog .cate {
    display: block;
  }
  .catalog .product ul li {
    width: 50%;
  }
  .catalog .product-img img:hover {
    width: 270px !important;
  }
  .content {
    width: 100% !important;
  }
  .aside {
    display: none;
  }
  .catalog .cate {
    width: 100%;
    padding: 16px;
    box-sizing: border-box;
  }
  .catalog .cate .title {
    height: 24px;
    margin: 9px 0 25px;
    font-size: 19px;
    letter-spacing: -0.2px;
    text-align: left;
  }
  .catalog .cate .scoll {
    overflow-x: scroll;
  }
  .catalog .cate .scoll ul {
    white-space: nowrap;
    padding-bottom: 6px;
  }
  .catalog .cate .scoll ul li {
    display: inline-block;
    margin-right: 16px;
    width: 200px;
    height: 120px;
    border: 1px solid #ebebeb;
    cursor: pointer;
    overflow: hidden;
    background-color: #f5f5f5;
  }
  .catalog .cate .scoll ul li a {
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    color: inherit;
    cursor: pointer;
    text-decoration: none;
    outline: none;
  }
  .catalog .search {
    margin-top: 32px;
  }
}
@media only screen and (max-width: 600px) {
  .catalog .product ul li {
    width: 100%;
  }
  .content {
    width: 100%;
  }
  .catalog .search {
    margin-top: 32px;
  }
}
</style>
